export default {
    // The install method will be called with the Vue constructor as
    // the first argument, along with possible options
    install(Vue, store, router, options) {

        Vue.prototype.$checkEmail = (inputEmail) => {
            var filter = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
            if (filter.test(inputEmail))
                return true;
            else {
                return false;
            }
        }

        Vue.prototype.$checkPhone = (inputNumber) => {
            var filter = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
            if (filter.test(inputNumber))
                return true;
            else {
                return false;
            }
        }

        Vue.prototype.$storeNavigationMenuLinksAndRedirect = (navLinks, allowRouting) => {  
            var formattedNavLinks = JSON.parse(navLinks);
            if (formattedNavLinks.length) {
                // Update our store with Navigation menu links
                store.commit('setNavigationMenuLinks', formattedNavLinks);
                if (allowRouting) {
                    // Fetch the first link from our list and route the user to that component
                    router.push({ path: formattedNavLinks[0].PageLink });
                }                
            } else {
                // If no data is received and we cannot find links in our store, redirect the user to Home component
                var navLinksFromStore = store.getters.getNavigationMenuLinks;
                if (navLinksFromStore.length) {
                    router.push({ name: navLinksFromStore[0].PageLink });
                } else {
                    router.push({ name: "Home" });
                }                
            }
        }

        Vue.prototype.$inArray = (searchVal, arrayVal) => {
            var length = arrayVal.length;
            for (var i = 0; i < length; i++) {
                if (arrayVal[i] === searchVal) {
                    return true;
                }
            }
            return false;
        }

        // Turn a numeric time into a string time.
        Vue.prototype.$calcTimeString = (time) => {
            if (time === 0) {
                return "12:00 am";
            }
            if (time <= 11) {
                return time + ":00 am";
            }
            if (time === 12) {
                return "12:00 pm";
            }
            return (time - 12) + ":00 pm";
        }

        // Replaces a starting ( with a negative (-) sign, then removes "," , ")", and "$"... may need to be expanded if we ever go more global.
        // Basically used so we can do sorting with numbers in currency (c) or numeric (n) string format without including the numeric version of them.
        Vue.prototype.$changeNumeric = (num) => {
            return num.replace(/^\(/, '-').replace('$', '').replace(/,/g, '').replace(/\)\s*$/, "");
        }

        // If you need to do special handling with IE, here's how you determine if the user has IE.
        Vue.prototype.$usingIE = () => {
            var ua = window.navigator.userAgent;
            var msie = ua.indexOf("MSIE ");
            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
                // If Internet Explorer, return true
                return true;
            } 
            return false;
        }

        // Returns a base64 byte string, mostly used if you need to create a PDF.
        Vue.prototype.$base64ToArrayBuffer = (base64) => {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
               var ascii = binaryString.charCodeAt(i);
               bytes[i] = ascii;
            }
            return bytes;
         }

         // Takes an array of bytes and turns it into an array; used in conjunction with the function above.
         Vue.prototype.$saveByteArray = (reportName, byte) => {
            var blob = new Blob([byte], {type: "application/pdf"});
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            var fileName = reportName;
            link.download = fileName;
            link.click();
        }

        Vue.prototype.$httpAxiosBaseUrl = () => {            
            return "/Portal/";
        }

        Vue.prototype.$formatOldCustomerPortalLinks = (baseUrl, path) => {
            var redirectLink = path.indexOf("/") === 0 ? path.replace("/~/", "") : path.replace("~/", "");
            return window.location.protocol + "//" + window.location.host + baseUrl + redirectLink;
        }

        Vue.prototype.$formatResponseLinks = (response) => {
            // Format Portal links that we get back as part of the AJAX response, we will need to globally replace '~/' with 'Portal' keyword
            if (response.indexOf('~/') > 0) {
                return response.replace(new RegExp('~/', 'g'), Vue.prototype.$httpAxiosBaseUrl());
            } else {
                return response;
            }
        }

        //-------------------------------------------------------------------------------------------------------------------------//

        // Constants (Enums)

        // Layout Types: Simple Layout is used by non-dashboard pages (Login, Register, Forgot Username/Password)
        // App Layout is used by all the dashboard/customer pages (Home, Notifications, Reports, Charts etc)
        Vue.prototype.$LayoutType = {
            AppLayout: "AppLayout",
            SimpleLayout: "SimpleLayout"
        }

        Vue.prototype.$ResponseType = {
            Error: "error",
            Success: "success"
        }

        // Message Notification Opt In Statuses
        Vue.prototype.$OptIns = {
            OptIn: 1,
            OptInPending: 2,
            OptOutPending: 3,
            OptedOut: 4
        }

        // Notification Contact Types
        Vue.prototype.$contactTypes = {
            Text: 1,
            Voice: 2,
            Email: 3,
            Critical: 4
        }

        // Notification ModalTypes
        Vue.prototype.$modalTypes = {
            None: 0,
            Add: 1,
            Verify: 2,
            Delete: 3,
            EditNotificationWindow: 4,
            Address: 5
        }
        
        //Specific report configurations
        Vue.prototype.$configureReportTypes = {
            StartDate: -1,
            EndDate: -2
        }

        // This is for reports that have special handling; just the Usage Statement for now.  There should be as few of these as possible.
        Vue.prototype.$reportTypes = {
            MeterStatusHistory: 86,
            UsageStatement: 32,
            NotificationHistory: 61
        }

        Vue.prototype.$thermostatTypes = {
            Nest: 1
        }

        Vue.prototype.$authorizationURLs = {
            NestAuthorization: "https://home.nest.com/login/oauth2?client_id=dd32245e-a03c-47d9-9a09-724d4eee026f&state=NestData"
        }

        Vue.prototype.$SyscfgPaymentProcessors = {
            PayGoProcessing: 19, 
            Checkout: 20
        }

        Vue.prototype.$LinkTarget = {
            SameTab: "self",
            NewTab: "_blank"
        }

        Vue.prototype.$PaymentAccountTypes = {
            None: 0,
            Visa: 1,
            MasterCard: 2,
            Checking: 3,
            Savings: 4,
            Discover: 5,
            AmEx: 6
        }

        Vue.prototype.$LoginResults = {
            Success: 0,
            InvalidUserName: 1,
            InvalidPassword: 2,
            LockedAccount: 3,
            GenericError: 4,
            SessionNotSetup: 5
        }

        Vue.prototype.$PageLink = {
            CsrEditHome: "~/SSL/CSR/CSR_Edit_Home.aspx",
            LogoImage: "~/SSL/Common/GetLogoImage.ashx?logoid="
        }

        Vue.prototype.$LogoType = {
            BigLogo: 1,
            SmallLogo: 2,
            Email: 3,
            Payment: 4,
            Favicon: 5
        }

        Vue.prototype.$SessionTimeoutType = {
            Normal: 15,
            PortalInIframe: 25
        }

        Vue.prototype.$ReportDislayLocation = {
            None: 0,
            ReportOnly: 1,
            CSVOnly: 2,
            ReportAndCSV: 3
        }
    }   
}
